<template>
  <div class="tipsFixed" v-if="tipsStatus">{{tipsText}}</div>
</template>
<script>
export default {
    data() {
        return {
            tipsStatus: false,
            tipsType: true,
            tipsText:'暂无内容',
        }
    },
    props:{
        // tipsText:{
        //     type: String,
        //     defaule: '暂无内容'
        // }
    },
    methods: {
        tipsShow(text){
            this.tipsText = text;
            if(this.tipsType){
                this.tipsStatus = true;
                setTimeout(()=>{
                    this.tipsStatus = false;
                    this.tipsType = true;
                },2300);
                this.tipsType = false;
            }
        }
    },
}
</script>
<style scoped lang="scss">
    @import "../style/variables.scss";
    .tipsFixed{
        bottom:30%;
        left:50%;
        z-index: 5000;
        padding:6px 14px;
        text-align: center;
        position: fixed;
        background:rgba(0,0,0,0.85);
        backdrop-filter: saturate(180%) blur(10px);
        @extend %placeX;
        @include h-radius(5px);
        @include h-fontSize(#ffffff,14px,20px);
    }
</style>